<div class="signup-container">
    <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
      <div class="col-12 d-flex">
        
        <div class="form-group col-6">
          <label for="first_name">First Name</label>
          <input pInputText id="first_name" formControlName="first_name" type="text"
            placeholder="Enter your first name" />
          <small *ngIf="signupForm.get('first_name')?.invalid && signupForm.get('first_name')?.touched">
            First name is required
          </small>
        </div>

        <div class="form-group col-6">
          <label for="last_name">Last Name</label>
          <input pInputText id="last_name" formControlName="last_name" type="text" placeholder="Enter your last name" />
          <small *ngIf="signupForm.get('last_name')?.invalid && signupForm.get('last_name')?.touched">
            Last name is required
          </small>
        </div>
      </div>

      <div class="col-12 d-flex">
        <div class="form-group col-6">
          <label for="email">Email</label>
          <span [pTooltip]="isLandlord ? 'Not editable for this account type' : ''" tooltipPosition="top" [style.display]="'block'">
            <input pInputText id="email" formControlName="email" type="email" placeholder="Enter your email" style="width:100%" />
          </span>
          <small *ngIf="signupForm.get('email')?.invalid && signupForm.get('email')?.touched">
            Valid email is required
          </small>
        </div>
        <div class="form-group col-6">
          <label for="phone">Phone</label>
          <!-- <input pInputText id="phone" formControlName="phone" type="text" placeholder="Enter your phone number" (input)="enforcePrefix($event)" maxlength="16"/> -->
          <input pInputText id="phone" formControlName="phone" type="text" placeholder="xxx-xxx-xxxx" mask="000-000-0000" [validation]="true"/>
          <div class="error text-danger" *ngIf="signupForm.controls['phone'].invalid && signupForm.controls['phone'].touched">
            <small class="text-danger" *ngIf="signupForm.get('phone')?.errors?.['required']">Phone Number is required.</small>
            <small class="text-danger"  *ngIf="signupForm.get('phone')?.errors?.['invalidUSPhone']">
              Kindly provide a valid US phone number in this formats:
              <code>000-000-0000</code>
              with a valid US area code.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="user_type">User Type</label>
        <span [pTooltip]="isLandlord ? 'Not editable for this account type' : ''" tooltipPosition="top" [style.display]="'block'">
          <p-dropdown styleClass="w-100" id="user_type" formControlName="user_type" [options]="availableUserTypes"
            placeholder="Select a User Type">
          </p-dropdown>
        </span>
      </div>

      <div class="form-group" *ngIf="userData">
        <label for="isActive">Status</label>
        <span [pTooltip]="isLandlord ? 'Not editable for this account type' : ''" tooltipPosition="top" [style.display]="'block'">
          <p-dropdown styleClass="w-100" id="isActive" formControlName="isActive" [options]="isActive">
          </p-dropdown>
        </span>
      </div>

      <div class="form-group">
      <label for="password">Password</label>
      <span class="right-icon-field">
        <input
          pInputText
          id="password"
          formControlName="password"
          [type]="showPassword ? 'text' : 'password'"
          placeholder="Enter your password"
        />
        <i
          class="pi"
          [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"
          (click)="togglePasswordVisibility()"
          style="cursor: pointer"
        ></i>
      </span>
    </div>


      <div class="d-flex justify-content-end mt-2 p-1">
        <p-button class="secondary-btn" type="submit"
          [disabled]="signupForm.invalid">Submit</p-button>
      </div>
    </form>
  </div>
  <p-toast></p-toast>